// Language switcher with cookie-based locale preference
window.addEventListener("DOMContentLoaded", (event) => {
  const langBtn = document.querySelector("#langBtn");
  const langNav = document.querySelector("#langNav");
  const localeGroup = document.querySelector("[data-locale-switcher-header]");

  if (langBtn && localeGroup) {
    // Toggle language menu
    langBtn.addEventListener("click", () => {
      const isActive = localeGroup.hasAttribute("data-active");
      
      if (isActive) {
        localeGroup.removeAttribute("data-active");
        langBtn.setAttribute("aria-expanded", "false");
      } else {
        localeGroup.setAttribute("data-active", "");
        langBtn.setAttribute("aria-expanded", "true");
      }
    });

    // Close menu when clicking outside
    document.addEventListener("click", (event) => {
      if (!langBtn.contains(event.target) && !langNav.contains(event.target)) {
        localeGroup.removeAttribute("data-active");
        langBtn.setAttribute("aria-expanded", "false");
      }
    });

    // Handle language selection and set cookie
    document.querySelectorAll("#langNav div div a").forEach((button) => {
      button.addEventListener("click", () => {
        const selectedLang = button.getAttribute("lang");
        handleLanguageSwitch(selectedLang);
      });
    });
  }

  // Set a cookie with a given name, value, and expiry (in days)
  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie =
      name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/;domain=openers-closers.com";
  };

  // Delete a cookie by name
  const deleteCookie = (name) => {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=openers-closers.com";
  };

  // Get all cookies that start with a prefix
  const getCookiesByPrefix = (prefix) => {
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(";");
    const matchingCookies = [];

    for (let i = 0; i < cookieArray.length; i++) {
      let c = cookieArray[i].trim();
      if (c.indexOf(prefix) === 0) {
        const cookieName = c.substring(0, c.indexOf("="));
        matchingCookies.push(cookieName);
      }
    }
    return matchingCookies;
  };

  // Main function to handle language preference logic
  // Language-based redirects using cookie existence
  // When a user sets their language with the locale switcher,
  // we store a language-specific cookie e.g. "lang_es" or "lang_en"
  // Netlify redirects can check for the existence of these cookies
  // to determine user's language preference
  const handleLanguageSwitch = (langCode) => {
    // Delete all existing lang_ cookies to avoid conflicts
    const existingLangCookies = getCookiesByPrefix("lang_");
    existingLangCookies.forEach((cookieName) => {
      deleteCookie(cookieName);
    });

    // Set the new language-specific cookie (e.g., lang_es, lang_en)
    const cookieName = `lang_${langCode}`;
    setCookie(cookieName, "1", 365); // Set for 1 year
    console.log("Language preference set:", langCode);
  };
});